// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as CopyADefault } from '../../../assets/icons/default/general/copy-a.svg?react';
import { ReactComponent as CopyASolid } from '../../../assets/icons/solid/general/COPY-A.svg?react';
import { createIcons } from '../../Icon';
const CopyAIcon = /* @__PURE__ */ createIcons('CopyA', {
    default: CopyADefault,
    solid: CopyASolid
});
CopyAIcon.supportedTypes = ['default', 'solid'];
CopyAIcon.category = 'general';
export default CopyAIcon;
